// import api from "../../../../../api";
// import React from "react";
// import values from "../../../../../values";
import React, { useState } from "react";
import { TModal } from "../../../../../types/common.type";
import { useQuery } from "react-query";
import values from "../../../../../values";
import api from "../../../../../api";
import { IFindTransaction } from "../../../../../types/common.interface";
import Context from "../../../../../context";
import FindDebtScreen from "..";
import utils from "../../../../../utils";
import { IPayDebtToDriver } from "../../../../../types/company.interface";

// import {useQuery} from "react-query";
// import {DebtContext} from "../../../../../context";

// type TModal = "SHOW" | "NONE" | "SETUP_ORDER";

const ParentTransactionContainer = () => {
  // ** ==============================================================================================================
  // **                                         Values Validations
  // ** ==============================================================================================================
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [showModal, setShowModal] = React.useState<TModal>("NONE");
  const [selectedDebt, setSelectedDebt] = useState<any>();
  const [selectedWithdrawal, setSelectedWithdrawal] = useState<string[]>([]);

  // !! ==============================================================================================================
  // !!                                           Start API Call
  // !! ==============================================================================================================

  const [requestParentTransaction, setRequestParentTransaction] =
    React.useState<IFindTransaction>({
      page: 1,
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
      payerOriginType: "PASSENGER",
      filters: {
        transactionStatus: "SUCCESS",
        payerOriginType:"PASSENGER"
      },
    });

  // ? Panel-wide academic year (سال تحصیلی). It has to be in the query key as well as the request, otherwise
  // ? react-query serves the previous year's cached rows when the year is switched.
  const { selectedYear } = React.useContext(Context.AcademicYear);

  const parentTransaction = useQuery(
    [values.useQueryKeys.parentTransaction, requestParentTransaction, selectedYear?._id],
    () => api.post.common.findTransaction({ ...requestParentTransaction, academicYear: selectedYear?._id })
  );

  // !! ==============================================================================================================
  // !!                                            End API Call
  // !! ==============================================================================================================

  // ?? ==============================================================================================================
  // ??                                            JSX Container
  // ?? ==============================================================================================================

  return (
    <Context.ParentTransactionScreen.Provider
      value={{
        isLoading,
        showModal,
        setIsLoading,
        setShowModal,
        requestParentTransaction,
        setRequestParentTransaction,
        parentTransaction,
      }}
    >
      <FindDebtScreen rqData={parentTransaction} showModalData={{}} />
    </Context.ParentTransactionScreen.Provider>
  );
};

export default ParentTransactionContainer;
